import React, { PropsWithChildren, useMemo } from 'react'
import { defaultTheme, ErrorBoundary } from '@yes.technology/react-toolkit'
import { Provider as ReduxProvider } from 'react-redux'
import { RouterProvider as ClientRouterProvider } from 'react-router'
import {
  StaticRouterProvider,
  StaticRouterProviderProps
} from 'react-router-dom/server'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { ThemeProvider } from 'styled-components'
import store from 'state/store'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import GenericErrorPage from 'infrastructure/GenericErrorPage'

import { persistStore } from 'redux-persist'
import { createClientReactRouter } from 'routing/createReactRouter'

function renderError() {
  return <GenericErrorPage />
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30000
    }
  }
})

const App = ({ children }: PropsWithChildren) => {
  return (
    <React.StrictMode>
      <ErrorBoundary renderOnError={renderError}>
        <ReduxProvider store={store}>
          <ThemeProvider theme={defaultTheme}>
            <QueryClientProvider client={queryClient}>
              {children}
            </QueryClientProvider>
          </ThemeProvider>
        </ReduxProvider>
      </ErrorBoundary>
    </React.StrictMode>
  )
}

export const ClientApp = () => {
  const persistor = useMemo(() => persistStore(store), [])
  const router = useMemo(() => createClientReactRouter(), [])

  return (
    <App>
      <PersistGate loading={null} persistor={persistor}>
        <ClientRouterProvider router={router} />
      </PersistGate>
    </App>
  )
}

export const ServerApp = ({ router, context }: StaticRouterProviderProps) => {
  return (
    <App>
      <StaticRouterProvider {...{ router, context }} />
    </App>
  )
}

export default App
